import BulkUploadObTags from "../../../views/BulkUploadObTags.js";
import MenuNames from "../../../constants/Menu/MenuNames.json";

const BulkUploadObTagsRoutes = [
    {
        menuName: MenuNames.BULK_UPLOAD_OB_TAGS,
        path: "/bulk-upload-ob-tags",
        component: BulkUploadObTags,
        exact: true,
    },
];

export default BulkUploadObTagsRoutes;
